module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-score-template"
  }, [(_vm.player) ? _c('div', {
    staticClass: "player-score",
    style: ({
      'color': _vm.player.color
    })
  }, [_c('div', {
    staticClass: "player"
  }, [_vm._v(_vm._s(_vm.player.name))]), _vm._v(" "), _c('div', {
    staticClass: "point"
  }, [_vm._v(_vm._s(_vm.points))])]) : _vm._e(), _vm._v(" "), _c('keyboard', {
    on: {
      "keyboardPress": _vm.onKeyboardPress
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ff7cbab!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditScore.vue
// module id = 106
// module chunks = 2